module.exports = __webpack_public_path__ + "assets/img/kv-58d17e08.jpg";